(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    let grid = document.getElementById("compliments-grid");
    let loadMore = document.getElementById("compliments-loadmore");

    if (grid && loadMore) {
      let totalPages = loadMore.dataset.totalPages;
      let formId = loadMore.dataset.formId;
      let pageId = loadMore.dataset.pageId;
      let complimentFor = loadMore.dataset.complimentFor;
      let loadingText = loadMore.dataset.loadingText;
      let offset = loadMore.dataset.offset;
      let pageNumber = 2;

      let innerSpan = loadMore.firstElementChild?.firstElementChild?.children[1];
      let initialText = innerSpan?.innerText;

      loadMore.addEventListener("click", () => {
        let surfaceControllerUrl = `/umbraco/surface/complimentssurface/loadmorecompliments?formId=${formId}&pageId=${pageId}&pageNumber=${pageNumber}&totalPages=${totalPages}&offset=${offset}`;

        if (innerSpan) {
          innerSpan.innerText = loadingText;
        }

        fetch(surfaceControllerUrl)
          .then((response) => response.json())
          .then((json) => {
            if (json && json.length > 0) {
              json.forEach(element => {
                let card = document.createElement("div");
                card.setAttribute("class", `mol-compliments-card${element.modifier ? " " + element.modifier : ""}`);

                if (element.title) {
                  let title = document.createElement("h4");
                  let br = document.createElement("br");
                  let strong = document.createElement("strong");
                  strong.innerText = element.title;

                  title.innerText = complimentFor;
                  title.appendChild(br);
                  title.appendChild(strong);
                  card.appendChild(title);
                }

                let content = document.createElement("div");
                content.setAttribute("class", "compliment-content");

                if (element.image) {
                  let picture = document.createElement("picture");
                  picture.setAttribute("class", "atm-image");

                  let img = document.createElement("img");
                  img.setAttribute("class", "picture-image");

                  if (element.image.cropUrl) {
                    img.setAttribute("src", element.image.cropUrl);
                  }

                  img.setAttribute("alt", element.image.alt || "");

                  if (element.image.lazy) {
                    img.setAttribute("loading", "lazy");
                  }

                  picture.appendChild(img);
                  content.appendChild(picture);
                } else if (element.complimentText) {
                  let paragraph = document.createElement("div");
                  paragraph.setAttribute("class", "atm-paragraph");

                  let p = document.createElement("p");
                  p.innerText = element.complimentText.text;

                  paragraph.appendChild(p);
                  content.appendChild(paragraph);

                  let author = document.createElement("div");
                  author.setAttribute("class", "author");
                  author.innerText = element.name + " - " + element.company;

                  content.appendChild(author);
                }

                card.appendChild(content);
                grid.appendChild(card);
              });

              if (pageNumber >= totalPages) {
                loadMore.classList.add("!hidden");
              } else {
                pageNumber++;
                innerSpan.innerText = initialText;
              }
            }
          });
      });
    }
  });

})();
